const EnvelopeIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_8461_7713"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="80"
      height="80"
    >
      <path
        d="M72 0H8C3.58172 0 0 3.58172 0 8V72C0 76.4183 3.58172 80 8 80H72C76.4183 80 80 76.4183 80 72V8C80 3.58172 76.4183 0 72 0Z"
        fill="#FFCCEF"
      />
    </mask>
    <g mask="url(#mask0_8461_7713)">
      <path d="M80 0H0V80H80V0Z" fill="#F4EFED" />
      <rect y="46.667" width="80" height="33.3333" fill="#0A0777" />
      <path d="M40 6.66699L0 46.667H80L40 6.66699Z" fill="#0A0777" />
      <rect x="16" y="48.5" width="48" height="11.5" fill="white" />
      <path
        d="M53.7528 46.798C51.5578 41.3507 46.2315 37.5 39.9984 37.5C33.7652 37.5 28.4374 41.3492 26.2439 46.798C25.5553 48.5089 25.1665 50.3741 25.1665 52.3313C25.1665 55.1418 25.9635 57.7608 27.3214 60H52.6783C54.0362 57.7608 54.8332 55.1418 54.8332 52.3313C54.8332 50.3741 54.4443 48.5089 53.7557 46.798H53.7528Z"
        fill="#FB6E44"
      />
    </g>
  </svg>
);

export default EnvelopeIcon;
